<template>
    <c-dialog ref="dialog" width="520px" mask-close @resolve="submitHandle">
        <c-form ref="form" vertical unit-width="100%">
            <c-form-item label="盘点单号">
                <c-input
                    name="check_code"
                    placeholder="请输入，忽略将自动生成"
                    :disabled="isEdit"
                ></c-input>
            </c-form-item>

            <c-form-item label="盘点部门" required>
                <c-select
                    ref="deptSelect"
                    name="dept_id"
                    v-model="check_dept"
                    async
                    placeholder="请选择"
                    :value-data="deptOptions"
                    :clear="false"
                    @search="searchDept"
                    @change="changeDept"
                ></c-select>
            </c-form-item>

            <c-form-item label="盘点人员" required>
                <c-select
                    ref="userSelect"
                    name="check_user_id"
                    async
                    placeholder="请选择人员"
                    :value-data="userOptions"
                    :disabled="!check_dept"
                    :clear="false"
                    @search="searchUser"
                ></c-select>
            </c-form-item>
        </c-form>

        <template #button>
            <c-button size="dialog" color="main" @click="submitHandle">确定</c-button>
            <c-button size="dialog" @click="$refs.dialog.close()">取消</c-button>
        </template>
    </c-dialog>
</template>

<script>
    export default {
        name: 'inventoryEdit',

        data() {
            return {
                isEdit: false,
                check_id: '',
                check_dept: '',
                deptOptions: [],
                userOptions: []
            }
        },

        methods: {
            /*********打开弹框**********/
            open(data) {
                this.isEdit = !!(data && data.id);
                this.check_id = data ? data.id : '';
                this.check_dept = '';
                this.deptOptions = [];
                this.userOptions = [];

                this.$refs.form.clear();

                if (data && data.id) {
                    var formData = {
                        check_code: data.check_code || '',
                        check_dept: data.check_dept || '',
                        check_user_id: data.check_user_id || ''
                    };
                    this.$refs.form.set(formData);
                    this.check_dept = data.check_dept || '';

                    if (data.check_dept) {
                        this.deptOptions = [{
                            name: data.check_dept_name,
                            value: data.check_dept
                        }];
                    }
                    if (data.check_user_id) {
                        this.userOptions = [{
                            name: data.check_user_name,
                            value: data.check_user_id
                        }];
                    }
                }

                this.$refs.dialog.open({title: this.isEdit ? '编辑盘点任务' : '创建盘点任务'});
            },

            /*******搜索部门*****************/
            searchDept(keyword, resolve) {
                this.request({
                    url: '/system/options',
                    data: {
                        options_code: 'DEPARTMENT',
                        keyword: keyword
                    },
                    success: data => {
                        resolve(data);
                    }
                })
            },

            /*******变更部门*****************/
            changeDept() {
                this.$refs.form.set({
                    check_dept: ''
                });
                this.userOptions = [];
            },

            /*******搜索人员*****************/
            searchUser(keyword, resolve) {
                if (!this.check_dept) {
                    resolve([]);
                    return;
                }
                this.request({
                    url: '/system/options',
                    data: {
                        options_code: 'SYSUSER',
                        department_id: this.check_dept,
                        keyword: keyword
                    },
                    success: data => {
                        resolve(data);
                    }
                })
            },

            /*********提交**********/
            submitHandle() {
                this.$refs.form.submit({
                    url: this.isEdit ? '/inventory/update' : '/inventory/create',
                    rule: {
                        dept_id: '请选择盘点部门',
                        check_user_id: '请选择盘点人员'
                    },
                    dataFormatter: data => {
                        data.id = this.check_id;
                        return data;
                    },
                    success: (res, msg) => {
                        this.$refs.dialog.close();
                        this.$message({message: this.isEdit ? '更新成功' : '创建成功', type: 'success'});
                        this.$emit('resolve');
                    },
                    fail: (msg) => {
                        this.$message({message: msg, type: 'error'});
                    }
                });
            }
        }
    }
</script>

<style lang="stylus" scoped>
</style>
